function initialiseConsumerDisclaimer () {
  $("#consumer-disclosure-icon").click(function (event) {
    event.stopPropagation();
    $("#consumer-disclosure-tooltip").toggleClass("m-fadeIn");
  });

  $("body").click(function () {
    if ($("#consumer-disclosure-tooltip").hasClass("m-fadeIn")) {
      $("#consumer-disclosure-tooltip").toggleClass("m-fadeIn");
    };
  });
};

$(function () {
  initialiseConsumerDisclaimer();

  OT.Events.on('results:done', function(){
    initialiseConsumerDisclaimer();
  });
});